module.exports = __webpack_public_path__ + "img/receipt-empty.1d8674af.png";